import { useState } from 'react'
import { cn } from '@utils/cn'

function publicAssetUrl(path: string): string {
  const base = import.meta.env.BASE_URL || '/'
  const normalized = path.startsWith('/') ? path : `/${path}`
  if (base === '/') return normalized
  return `${base.replace(/\/$/, '')}${normalized}`
}

/** Safari: PNG com fundo #17253C; Chromium: variante transparente (evita caixa visível no Chrome). */
function getBrandLogoSrc(): string {
  const isSafari =
    typeof CSS !== 'undefined' &&
    typeof CSS.supports === 'function' &&
    CSS.supports('-webkit-touch-callout', 'none')
  return publicAssetUrl(isSafari ? '/FIXDAUTO.png' : '/FIXDAUTO-transparent.png')
}

interface BrandLogoProps {
  readonly className?: string
  readonly alt?: string
}

export function BrandLogo({ className, alt = 'FIXDAUTO' }: BrandLogoProps) {
  const [logoSrc] = useState(getBrandLogoSrc)
  return <img src={logoSrc} alt={alt} className={cn('w-auto object-contain', className)} />
}
